import axios from "axios";
import { API, SERVER_URL } from '../constants/api';
import cookieStorage from "../services/cookie-storage";
import HttpService from "../services/http-service";
import { serialize } from "./../constants/function";
import { clearPendingReferral, withPendingReferral } from "../utils/gamification/pendingReferral";
const config = {
  headers: {
    Authorization: "",
  },
};
export const header = {
  headers: {
    Authorization: cookieStorage.getCookie("Authorization"),
    
    // "Content-Type": "application/json",
    // "Access-Control-Allow-Origin": "*",
  },
};
const forgetReferralOnSuccess = (response) => {
  clearPendingReferral();
  return response;
};
export default class ApiService {
  static async getToken(tempToken) {
    const token = tempToken
      ? tempToken
      : cookieStorage.getCookie("Authorization") || localStorage.getItem("token");

    // CRITICAL FIX: Backend expects "Bearer <token>" format, not just the token
    if (token) {
      config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    }
    config.headers["Content-Type"] = "application/json";
    config.withCredentials = true;

    // config.headers["Access-Control-Allow-Origin"] = "*";
  }
 // Admin: Feature/Unfeature Artist
static async ADMIN_FEATURE_ARTIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_FEATURE_ARTIST, payload, config);
}
static async ADMIN_UNFEATURE_ARTIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_ARTIST, payload, config);
}

// Admin: Feature/Unfeature Music
static async ADMIN_FEATURE_MUSIC(payload) {
  await this.getToken();
  console.log('[API SERVICE] ADMIN_FEATURE_MUSIC payload:', JSON.stringify(payload));
  return HttpService.post(API.ADMIN_FEATURE_MUSIC, payload, config);
}
static async ADMIN_UNFEATURE_MUSIC(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_MUSIC, payload, config);
}

// Admin: Feature/Unfeature Video
static async ADMIN_FEATURE_VIDEO(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_FEATURE_VIDEO, payload, config);
}
static async ADMIN_UNFEATURE_VIDEO(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_VIDEO, payload, config);
}

// Admin: Feature/Unfeature Playlist
static async ADMIN_FEATURE_PLAYLIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_FEATURE_PLAYLIST, payload, config);
}
static async ADMIN_UNFEATURE_PLAYLIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_PLAYLIST, payload, config);
}

static async ADMIN_REMOVE_FEATURED_PLAYLIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_PLAYLIST, payload, config);
}

static async ADMIN_GET_ALL_USERS(keywords) {
  const params = serialize(keywords); // Serialize the keywords into a query string
  await this.getToken(); // Ensure the token is set
  const requestUrl = `${API.ADMIN_GET_ALL_USERS}?${params}`; // Construct the full URL with ?
  console.log("Request URL:", requestUrl); // Debugging log
  return HttpService.get(requestUrl, config); // Make the GET request
}

  static async ADMIN_END_LIVESTREAM(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_END_LIVESTREAM, payload, config);
  }

  // Livestream Monitoring
  static async LIVESTREAM_MONITOR_CHECK() {
    await this.getToken();
    return HttpService.get(API.LIVESTREAM_MONITOR_CHECK, config);
  }

  static async LIVESTREAM_MONITOR_CLEANUP(payload) {
    await this.getToken();
    return HttpService.post(API.LIVESTREAM_MONITOR_CLEANUP, payload, config);
  }

  static async LIVESTREAM_MONITOR_STATUS() {
    await this.getToken();
    return HttpService.get(API.LIVESTREAM_MONITOR_STATUS, config);
  }

  static async LIVESTREAM_MONITOR_ALERTS(limit = 20) {
    await this.getToken();
    return HttpService.get(`${API.LIVESTREAM_MONITOR_ALERTS}?limit=${limit}`, config);
  }

  // Admin Test Chat
  static async ADMIN_TEST_CHAT_SEND(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_TEST_CHAT_SEND, payload, config);
  }

  static async ADMIN_TEST_CHAT_LIVESTREAMS() {
    await this.getToken();
    return HttpService.get(API.ADMIN_TEST_CHAT_LIVESTREAMS, config);
  }

  static async ADMIN_TEST_USER_POOL_USERS(count = 50) {
    await this.getToken();
    return HttpService.get(`${API.ADMIN_TEST_USER_POOL_USERS}?count=${count}`, config);
  }

  static async ADMIN_TEST_CHAT_STREAM_USERS(channelName) {
    await this.getToken();
    return HttpService.get(`${API.ADMIN_TEST_CHAT_STREAM_USERS}?channelName=${channelName}`, config);
  }

  // Admin: Error Logs
  static async ADMIN_GET_ERROR_LOGS(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_ERROR_LOGS}?${queryString}`, config);
  }

  static async ADMIN_GET_ERROR_LOG_DETAIL(id) {
    await this.getToken();
    return HttpService.get(`${API.ADMIN_ERROR_LOGS}/${id}`, config);
  }

  static async ADMIN_GET_ERROR_STATS(hours = 24) {
    await this.getToken();
    return HttpService.get(`${API.ADMIN_ERROR_LOG_STATS}?hours=${hours}`, config);
  }

  // Admin: Get a user's streaming balance
static async ADMIN_GET_USER_STREAMING_BALANCE(userId) {
  await this.getToken();
  // userId as query param
  return HttpService.get(`${API.ADMIN_USER_STREAMING_BALANCE}?userId=${userId}`, config);
}

// Admin: Add to a user's streaming balance
static async ADMIN_ADD_USER_STREAMING_BALANCE(payload) {
  await this.getToken();
  // payload: { userId, amount }
  return HttpService.post(API.ADMIN_USER_STREAMING_BALANCE, payload, config);
}

static async ADMIN_VERIFY_USER(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_VERIFY_ARTIST, payload, config);
}

// Admin: Freeze user
static async ADMIN_FREEZE_USER(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_FREEZE_USERS, payload, config);
}

// Admin: Get flagged assets list
static async ADMIN_GET_FLAGS(params = {}) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_GET_FLAGS}?${queryString}`, config);
}

// Admin: Review flag (approve/reject)
static async ADMIN_REVIEW_FLAG(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_REVIEW_FLAG, payload, config);
}

// Admin: Restore content (counter-notice)
static async ADMIN_RESTORE_CONTENT(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_RESTORE_CONTENT, payload, config);
}

// Admin: Get user balance
static async ADMIN_GET_USER_BALANCE(userId) {
  await this.getToken();
  return HttpService.get(`${API.ADMIN_BALANCE}?userId=${userId}`, config);
}

// Admin: Update user profile
static async ADMIN_UPDATE_USER_PROFILE(userId, formData) {
  await this.getToken();
  config.headers["Content-Type"] = "multipart/form-data";
  return HttpService.post(`${API.ADMIN_USER}/${userId}/profile`, formData, config);
}

// Admin: Upload music for user
static async ADMIN_UPLOAD_MUSIC_FOR_USER(userId, formData) {
  await this.getToken();
  config.headers["Content-Type"] = "multipart/form-data";
  return HttpService.post(`${API.ADMIN_USER}/${userId}/music`, formData, config);
}

// Admin: Upload video for user
static async ADMIN_UPLOAD_VIDEO_FOR_USER(userId, formData) {
  await this.getToken();
  config.headers["Content-Type"] = "multipart/form-data";
  return HttpService.post(`${API.ADMIN_USER}/${userId}/video`, formData, config);
}

// Admin: Create studio for user
static async ADMIN_CREATE_STUDIO_FOR_USER(userId, formData) {
  await this.getToken();
  config.headers["Content-Type"] = "multipart/form-data";
  return HttpService.post(`${API.ADMIN_USER}/${userId}/studio`, formData, config);
}

// Admin: Get user content stats
static async ADMIN_GET_USER_STATS(userId) {
  await this.getToken();
  return HttpService.get(`${API.ADMIN_USER}/${userId}/stats`, config);
}

// Admin: Get user content lists
static async ADMIN_GET_USER_CONTENT(userId, contentType = 'all', page = 1, limit = 20) {
  await this.getToken();
  const params = new URLSearchParams({ contentType, page: page.toString(), limit: limit.toString() });
  return HttpService.get(`${API.ADMIN_USER_CONTENT}/${userId}/content?${params.toString()}`, config);
}

// Admin: Delete user content
static async ADMIN_DELETE_USER_CONTENT(userId, contentType, contentId) {
  await this.getToken();
  return HttpService.delete(`${API.ADMIN_USER}/${userId}/${contentType}/${contentId}`, config);
}

// Admin: Role management (only chris@siki.io can access)
static async ADMIN_MANAGE_ROLE(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_MANAGE_ROLE, payload, config);
}

static async ADMIN_GET_ADMIN_USERS() {
  await this.getToken();
  return HttpService.get(API.ADMIN_GET_ADMIN_USERS, config);
}

// Admin: Moderator role management
static async ADMIN_MANAGE_MODERATOR_ROLE(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_MANAGE_MODERATOR_ROLE, payload, config);
}

static async ADMIN_GET_MODERATOR_USERS() {
  await this.getToken();
  return HttpService.get(API.ADMIN_GET_MODERATOR_USERS, config);
}

// Moderator management dashboard
static async ADMIN_GET_MANAGED_USERS() {
  await this.getToken();
  return HttpService.get(API.ADMIN_MANAGED_USERS, config);
}

static async ADMIN_GET_UNMANAGED_USERS(params = {}) {
  await this.getToken();
  const qs = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_UNMANAGED_USERS}?${qs}`, config);
}

static async ADMIN_CLAIM_USER(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_CLAIM_USER, payload, config);
}

static async ADMIN_RELEASE_USER(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_RELEASE_USER, payload, config);
}

static async ADMIN_UPDATE_ONBOARDING(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UPDATE_ONBOARDING, payload, config);
}

static async ADMIN_SET_LIVESTREAM_DEADLINE(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_SET_LIVESTREAM_DEADLINE, payload, config);
}

static async ADMIN_SEARCH_USERS_FOR_POOL(params) {
  await this.getToken();
  const qs = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_SEARCH_USERS_FOR_POOL}?${qs}`, config);
}

static async ADMIN_SET_AVAILABLE(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_SET_AVAILABLE, payload, config);
}

// Admin: Search artists
static async ADMIN_SEARCH_ARTIST(params) {
  await this.getToken();
  const queryString = params.query ? `?keyword=${encodeURIComponent(params.query)}` : '';
  return HttpService.get(`${API.ADMIN_SEARCH_ARTIST}${queryString}`, config);
}

// Admin: Get all playlists
static async ADMIN_GET_ALL_PLAYLISTS(params = {}) {
  await this.getToken();
  const queryString = params.query ? `?query=${encodeURIComponent(params.query)}` : '';
  return HttpService.get(`${API.ADMIN_GET_ALL_PLAYLISTS}${queryString}`, config);
}

// Admin: SIKI ledger entries (paged, filterable)
static async ADMIN_GET_LEDGER_TRANSACTIONS(params) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_LEDGER_TRANSACTIONS}?${queryString}`, config);
}

// Admin: SIKI ledger supply / activity / frozen-account summary
static async ADMIN_GET_LEDGER_SUMMARY(params = {}) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_LEDGER_SUMMARY}?${queryString}`, config);
}

// Admin: nightly growth summaries (active users, funnel, retention, segments, push holdout)
static async ADMIN_GET_GROWTH_METRICS(params = {}) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_GROWTH_METRICS}?${queryString}`, config);
}

// Admin: business agents (owner-only). Every response is the usual envelope;
// the shapes of `result` are documented in skcore controller/adminAgentsController.js.
static async ADMIN_GET_AGENTS() {
  await this.getToken();
  return HttpService.get(API.ADMIN_AGENTS, config);
}

// payload: { monthlyBudgetUsd: number|null }
static async ADMIN_UPDATE_AGENTS_SETTINGS(payload) {
  await this.getToken();
  return HttpService.patch(API.ADMIN_AGENTS_SETTINGS, payload, config);
}

// payload: { enabled: boolean }
static async ADMIN_UPDATE_AGENT(agentKey, payload) {
  await this.getToken();
  return HttpService.patch(`${API.ADMIN_AGENTS}/${encodeURIComponent(agentKey)}`, payload, config);
}

static async ADMIN_RUN_AGENT(agentKey) {
  await this.getToken();
  return HttpService.post(`${API.ADMIN_AGENTS}/${encodeURIComponent(agentKey)}/run`, {}, config);
}

// params: { agentKey?, status?, limit?, before? }
static async ADMIN_GET_AGENT_RUNS(params = {}) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_AGENT_RUNS}?${queryString}`, config);
}

static async ADMIN_GET_AGENT_RUN(runId) {
  await this.getToken();
  return HttpService.get(`${API.ADMIN_AGENT_RUNS}/${encodeURIComponent(runId)}`, config);
}

// params: { status?: "open"|"handled", kind?, agentKey?, limit?, before? }
static async ADMIN_GET_AGENT_ITEMS(params = {}) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_AGENT_ITEMS}?${queryString}`, config);
}

// edits: only the changed fields, { to?, subject?, body? } or { text? }
static async ADMIN_APPROVE_AGENT_ITEM(itemId, edits = {}) {
  await this.getToken();
  return HttpService.post(`${API.ADMIN_AGENT_ITEMS}/${encodeURIComponent(itemId)}/approve`, edits, config);
}

static async ADMIN_REJECT_AGENT_ITEM(itemId) {
  await this.getToken();
  return HttpService.post(`${API.ADMIN_AGENT_ITEMS}/${encodeURIComponent(itemId)}/reject`, {}, config);
}

// params: { kind?, status?, q?, limit? }
static async ADMIN_GET_AGENT_CONTACTS(params = {}) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_AGENT_CONTACTS}?${queryString}`, config);
}

// Admin: Get user stream transactions
static async ADMIN_GET_USER_STREAM_TRANSACTIONS(params) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_USER_STREAM_TRANSACTIONS}?${queryString}`, config);
}

// Admin: Get user stream transaction summary
static async ADMIN_GET_USER_STREAM_SUMMARY(params) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_USER_STREAM_TRANSACTIONS_SUMMARY}?${queryString}`, config);
}

// Admin: Search users
static async ADMIN_SEARCH_USER(query) {
  await this.getToken();
  // Use the general user search endpoint which works better
  return HttpService.get(`${API.SEARCH_USER}${encodeURIComponent(query)}`, config);
}


  //Auth
  // Both sign-ins carry the share link a logged-out visitor arrived through
  // (see utils/gamification/pendingReferral); the server credits it only for
  // a new account.
  static async googleSignInWithToken(payload) {
    // Add redirect URI to payload based on current environment
    const enhancedPayload = {
      ...withPendingReferral(payload),
      redirectUri: `${window.location.origin}/auth/google/callback`
    };
    return HttpService.post(`${API.googleLogin}`, enhancedPayload, config).then(forgetReferralOnSuccess);
  }
  static async appleSignInWithToken(payload) {
    return HttpService.post(`${API.appleLogin}`, withPendingReferral(payload), config).then(forgetReferralOnSuccess);
  }
  static async testUserLogin(payload) {
    await this.getToken();
    return HttpService.post(API.testUserLogin, payload, config);
  }
  static async addUsersToStream(payload) {
    await this.getToken();
    return HttpService.post(API.addUsersToStream, payload, config);
  }

  static async registerDeviceToken(payload) {
    await this.getToken();
    return HttpService.post(API.REGISTER_DEVICE_TOKEN, payload, config);
  }
  static async INVITE_COLLABORATOR(payload) {
    await this.getToken();
    return HttpService.post(`${API.INVITE_COLLABORATOR}`, payload, config);
  }
  static async INVITE_ROYALTIES(payload) {
    await this.getToken();
    return HttpService.post(`${API.INVITE_ROYALTIES}`, payload, config);
  }

  static async FUNDINGLINK(body, token) {
    await this.getToken(token);
    return HttpService.post(API.FUNDLINK, body, config);
  }

  static async PAYPALLINK(body, token) {
    await this.getToken(token);
    return HttpService.post(API.PAYPALLINK, body, config);
  }

  static async PAYPALLCAPTURE(payload) {
    await this.getToken();
    const query = serialize(payload);
    return HttpService.get(`${API.PAYPALLCAPTURE}` + query, config);
  }

  static async PAYPALLCANCEL(params) {
    await this.getToken();
    return HttpService.get(`${API.PAYPALLCANCEL}${params}`, config);
  }

  //user
  static async USER_DETAILS(payload) {
    await this.getToken();
    return HttpService.get(`${API.USER_DETAILS}` + payload, config);
  }
  static async FEATURE_USER(params) {
    await this.getToken();
    return HttpService.get(`${API.FEATURE_USER}${params}`, config);
  }
  static async FEATURE_ARTIST(params) {
    await this.getToken();
    return HttpService.get(`${API.FEATURE_ARTIST}${params}`, config);
  }

  static async SEARCH_USER(keyword) {
    await this.getToken();
    return HttpService.get(`${API.SEARCH_USER}` + keyword, config);
  }
  static async UPDATE_USER(payload) {
    await this.getToken();
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(`${API.UPDATE_USER}`, payload, config);
  }
  static async PROFILE_UPDATE(payload) {
    await this.getToken();
    return HttpService.post(`${API.PROFILE_UPDATE}`, payload, config);
  }
  static async ADD_TOP_MUSIC(payload) {
    await this.getToken();
    return HttpService.post(`${API.ADD_TOP_MUSIC}`, payload, config);
  }
  static async USER_NFT_MUSIC(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.USER_NFT_MUSIC}` + query, config);
  }
  static async USER_NFT_PLAYLIST(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.USER_NFT_PLAYLIST}` + query, config);
  }
  static async USER_PROFILE(token) {
    await this.getToken(token);
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.get(`${API.USER_PROFILE}`, config);
  }
  static async FLAG_USER(payload) {
    await this.getToken();
    return HttpService.post(`${API.FLAG_USER}`, payload, config);
  }
  static async ATTRIBUTES(token) {
    await this.getToken(token);

    return HttpService.get(`${API.ATTRIBUTES}`, config);
  }

  // Add this with your other API methods

static async SET_USER_TIMEZONE(timezone) {
  await this.getToken();
  return HttpService.post(`${API.SET_USER_TIMEZONE}`, { timezone }, config);
}

  //Subscription
  static async UPDATE_SUBSCRIPTION(payload) {
    await this.getToken();
    return HttpService.post(`${API.UPDATE_SUBSCRIPTION}`, payload, config);
  }
  static async GET_SUBSCRIPTIONS(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_SUBSCRIPTIONS}` + params, config);
  }
  static async CREATE_SUBSCRIPTIONS(payload) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_SUBSCRIPTIONS}`, payload, config);
  }
  static async RENEWAL_SUBSCRIPTION_URL(params) {
    await this.getToken();
    return HttpService.post(
      `${API.RENEWAL_SUBSCRIPTION_URL}${params}`,
      { autoRenewal: params },
      config
    );
  }
  static async SUBSCRIBE_ARTIST(payload) {
    await this.getToken();
    return HttpService.post(`${API.SUBSCRIBE_ARTIST}`, payload, config);
  }
  // Pay for someone else's subscription to an artist.
  // { artistId, recipientId, months?, message? }
  static async GIFT_ARTIST_SUBSCRIPTION(payload) {
    await this.getToken();
    return HttpService.post(`${API.GIFT_ARTIST_SUBSCRIPTION}`, payload, config);
  }
  static async UNSUBSCRIBE_ARTIST(payload) {
    await this.getToken();
    return HttpService.post(`${API.UNSUBSCRIBE_ARTIST}`, payload, config);
  }

  static async UNLOCKED_ASSETS(keywords) {
    await this.getToken();
    const query = serialize(keywords);
    return HttpService.get(`${API.UNLOCKED_ASSETS}` + query, config);
  }
  static async PRIVATE_ASSETS(id) {
    await this.getToken();
    return HttpService.get(`${API.PRIVATE_ASSETS}` + id, config);
  }

  //Music

  static async GET_UPLOAD_LIMITS() {
    await this.getToken();
    return HttpService.get(`${API.UPLOAD_LIMITS}`, config);
  }
  static async UPLOAD_MUSIC(payload) {
    await this.getToken();
    return HttpService.post(`${API.UPLOAD_MUSIC}`, payload, config);
  }

  static async MY_MUSIC(payload) {
    await this.getToken();
    return HttpService.get(`${API.MY_MUSIC}` + payload, config);
  }
  static async MUSIC_DETAIL(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_DETAIL}` + params, config);
  }

  static async FEATURE_MUSIC(payload) {
    await this.getToken();
    return HttpService.get(`${API.FEATURE_MUSIC}${payload}`, config);
  }
  static async SEARCH_MUSIC(keyword) {
    await this.getToken();
    return HttpService.get(`${API.SEARCH_MUSIC}` + keyword, config);
  }
  static async ALL_ARTIST_MUSIC(keywords) {
    const params = "?" + serialize(keywords);
    await this.getToken();
    return HttpService.get(`${API.ALL_ARTIST_MUSIC}` + params, config);
  }
  static async INDIVIDUAL_SONG_TIPPER(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.INDIVIDUAL_SONG_TIPPER}` + query, config);
  }
  static async TOP_STREAMERS_FOR_SONG(musicId, limit = 10) {
    await this.getToken();
    return HttpService.get(`${API.TOP_STREAMERS_FOR_SONG}${musicId}&limit=${limit}`, config);
  }
  static async PLAYLISTS_BY_SONG(musicId) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLISTS_BY_SONG}${musicId}`, config);
  }
  static async VIDEOS_BY_SONG(musicId) {
    await this.getToken();
    return HttpService.get(`${API.VIDEOS_BY_SONG}${musicId}`, config);
  }

  //Album
  static async MY_ALBUM(body) {
    await this.getToken();
    return HttpService.get(`${API.MY_ALBUM}` + body, config);
  }
  static async CREATE_ALBUM(body) {
    await this.getToken();
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(`${API.CREATE_ALBUM}`, body, config);
  }
  static async DELETE_ALBUM(params) {
    await this.getToken();
    return HttpService.get(`${API.DELETE_ALBUM}` + params, config);
  }
  static async ALBUM_DETAILS(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.ALBUM_DETAILS}` + query, config);
  }

  static async EDIT_ALBUM(body, params) {
    await this.getToken();
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(`${API.EDIT_ALBUM}${params}`, body, config);
  }
  static async ADD_SONGS_TO_ALBUM(payload) {
    await this.getToken();
    return HttpService.post(`${API.ADD_SONGS_TO_ALBUM}`, payload, config);
  }
  static async DELETE_SONG_FROM_ALBUM(payload) {
    await this.getToken();
    return HttpService.post(`${API.DELETE_SONG_FROM_ALBUM}`, payload, config);
  }
    static async PLAYLIST(params, isParams) {
      await this.getToken();
      if (isParams) {
        const query = serialize(params);
        return HttpService.get(`${API.MY_PLAYLIST}?${query}`, config);
      } else {
        return HttpService.get(`${API.PLAYLIST}${params}`, config);
      }
    }
  static async PLAYLIST_DETAIL(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.PLAYLIST_DETAIL}` + query, config);
  }

  static async CREATE_PLAYLIST(params) {
    await this.getToken();
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(`${API.CREATE_PLAYLIST}`, params, config);
  }
  static async EDIT_PLAYLIST(id, body) {
    await this.getToken();
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(
      `${API.EDIT_PLAYLIST}?playlistId=${id}`,
      body,
      config
    );
  }

  static async DELETE_PLAYLIST(params) {
    await this.getToken();
    return HttpService.get(`${API.DELETE_PLAYLIST}` + params, config);
  }

  static async FEATURE_PLAYLIST(params) {
    await this.getToken();
    return HttpService.get(`${API.FEATURE_PLAYLIST}${params}`, config);
  }

  static async GET_FEATURED_MUSIC(pageNo = 1, pageSize = 8) {
    await this.getToken();
    return HttpService.get(`${SERVER_URL}/music/featured/list?pageNo=${pageNo}&pageSize=${pageSize}`, config);
  }
  static async SEARCH_PLAYLIST(keyword) {
    await this.getToken();
    return HttpService.get(`${API.SEARCH_PLAYLIST}` + keyword, config);
  }
  static async ASSET_PRIVACY(payload) {
    await this.getToken();
    return HttpService.post(`${API.ASSET_PRIVACY}`, payload, config);
  }
  static async ADD_SONG_TO_PLAYLIST(payload) {
    await this.getToken();
    return HttpService.post(`${API.ADD_SONG_TO_PLAYLIST}`, payload, config);
  }
  static async REMOVE_SONG_FROM_PLAYLIST(payload) {
    await this.getToken();
    return HttpService.post(
      `${API.REMOVE_SONG_FROM_PLAYLIST}`,
      payload,
      config
    );
  }
  static async SAVE_PLAYLIST(payload) {
    await this.getToken();
    return HttpService.post(`${API.SAVE_PLAYLIST}`, payload, config);
  }
  static async GET_PLAYLIST_MUSIC(payload) {
    await this.getToken();
    return HttpService.get(`${API.GET_PLAYLIST_MUSIC}` + payload, config);
  }
  static async PLAYLIST_ALL_(payload) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_ALL_}` + payload, config);
  }
  static async SORT_PLAYLIST_MUSIC(payload) {
    await this.getToken();
    return HttpService.post(`${API.SORT_PLAYLIST_MUSIC}`, payload, config);
  }
  static async TOPTEN_MY_PLAYLIST(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.TOPTEN_MY_PLAYLIST}` + query, config);
  }
  static async TOPTEN_BUY_ME_PLAYLIST(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.TOPTEN_BUY_ME_PLAYLIST}` + query, config);
  }

static async GET_SAVES(type = null) {
  await this.getToken();
  const url = type ? `${API.SAVES}/${type}` : API.SAVES;
  console.log('GET_SAVES - Full URL:', url);
  console.log('GET_SAVES - API.SAVES:', API.SAVES);
  console.log('GET_SAVES - config:', config);
  return HttpService.get(url, config);
}

  static async ADD_SAVE(type, payload) {
    await this.getToken();
    return HttpService.post(`${API.SAVES}/${type}`, payload, config);
  }

static async REMOVE_SAVE(type, payload) {
  await this.getToken();
  // For DELETE requests, data goes in config.data
  return HttpService.delete(`${API.SAVES}/${type}`, {
    ...config,
    data: payload
  });
}

  //GENRE
  static async GENRE_LIST() {
    await this.getToken();
    return HttpService.get(`${API.GENRE_LIST}`, config);
  }

  //NFTs
  static async CREATE_PLAYLIST_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_PLAYLIST_NFT}`, body, config);
  }
  static async CREATE_PLAYLIST_NFT_V4(body) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_PLAYLIST_NFT_V4}`, body, config);
  }

  static async CREATE_MUSIC_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_MUSIC_NFT}`, body, config);
  }
  static async CREATE_MUSIC_NFT_V4(body) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_MUSIC_NFT_V4}`, body, config);
  }
  static async CREATE_MUSIC_NFT_V5(body, onUploadProgress) {
    await this.getToken();

    config.headers["Content-Type"] = "multipart/form-data";

    // Add upload progress callback if provided
    if (onUploadProgress) {
      config.onUploadProgress = onUploadProgress;
    }

    return HttpService.post(`${API.CREATE_MUSIC_NFT_V5}`, body, config);
  }
  static async DELETE_MUSIC(musicId) {
    await this.getToken();
    return HttpService.delete(`${API.UPLOAD_MUSIC.replace('/upload', '')}/delete/${musicId}`, config);
  }
  static async MUSIC_NFT() {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_NFT}`, config);
  }
  static async PLAYLIST_NFT() {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_NFT}`, config);
  }
  static async NFT_BY_ID(params) {
    await this.getToken();
    return HttpService.get(`${API.NFT_BY_ID}` + params, config);
  }
  static async NFT_BY_ID_V2(params) {
    await this.getToken();
    return HttpService.get(`${API.NFT_BY_ID_V2}` + params, config);
  }
  static async PLAYLIST_NFT_BY_ID(params) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_NFT_BY_ID}` + params, config);
  }

  static async BID_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.BID_NFT}`, body, config);
  }
  static async BID_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.BID_NFT_V2}`, body, config);
  }
  static async BUY_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.BUY_NFT}`, body, config);
  }
  static async BUY_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.BUY_NFT_V2}`, body, config);
  }
  static async BUY_MUSIC_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.BUY_MUSIC_NFT}`, body, config);
  }
  static async SELL_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.SELL_NFT}`, body, config);
  }
  static async SELL_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.SELL_NFT_V2}`, body, config);
  }
  static async AUCTION_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.AUCTION_NFT}`, body, config);
  }
  static async AUCTION_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.AUCTION_NFT_V2}`, body, config);
  }
  static async NFT_OFFERS(params) {
    await this.getToken();
    return HttpService.get(`${API.NFT_OFFERS}` + params, config);
  }
  static async CANCEL_SELL(body) {
    await this.getToken();
    return HttpService.post(`${API.CANCEL_SELL}`, body, config);
  }
  static async CANCEL_SELL_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.CANCEL_SELL_V2}`, body, config);
  }
  static async CANCEL_AUCTION_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.CANCEL_AUCTION_NFT}`, body, config);
  }
  static async CANCEL_AUCTION_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.CANCEL_AUCTION_NFT_V2}`, body, config);
  }


static async CREATE_CALENDAR_EVENT(payload) {
  await this.getToken();
  return HttpService.post(API.CREATE_CALENDAR_EVENT, payload, config);
}

// Add this with the other calendar methods

static async DELETE_CALENDAR_EVENT(eventId) {
  await this.getToken();
  // Make sure to properly replace the :id parameter
  const endpoint = API.DELETE_CALENDAR_EVENT.replace(':id', eventId);
  console.log('Delete endpoint:', endpoint); // Add this for debugging
  return HttpService.delete(endpoint, config);
}

static async FETCH_CALENDAR_EVENTS(userId) {
  await this.getToken();
  const query = `?userId=${userId}`;
  return HttpService.get(`${API.FETCH_CALENDAR_EVENTS}${query}`, config);
}

static async GET_TASKS(userId) {
  await this.getToken();
  return HttpService.get(`${API.GET_TASKS}?userId=${userId}`, config);
}

  //GET_NFT_FRACTIONS
  static async GET_NFT_FRACTIONS(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_NFT_FRACTIONS}` + params, config);
  }
  static async GIFT_NFT_FRACTIONS(body) {
    await this.getToken();
    return HttpService.post(`${API.GIFT_NFT_FRACTIONS}`, body, config);
  }
  // gift playlist nft
  static async GIFT_PLAYLIST_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.GIFT_PLAYLIST_NFT}`, body, config);
  }
  //GET all
  static async ALL_NFT(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.ALL_NFT}` + query, config);
  }
  //FOLLOW
  static async FOLLOWERLIST(params) {
    await this.getToken();
    return HttpService.get(`${API.FOLLOWERLIST}` + params, config);
  }
  static async FOLLOWINGLIST(params) {
    await this.getToken();
    return HttpService.get(`${API.FOLLOWINGLIST}` + params, config);
  }
  static async UNFOLLOW(body) {
    await this.getToken();
    return HttpService.post(`${API.UNFOLLOW}`, body, config);
  }
  static async FOLLOW(body) {
    await this.getToken();
    return HttpService.post(`${API.FOLLOW}`, body, config);
  }
  // Which of `userIds` the current user follows: { result: { following: [...] } }
  static async FOLLOW_STATUS(userIds) {
    await this.getToken();
    return HttpService.get(`${API.FOLLOW_STATUS}` + encodeURIComponent(userIds.join(",")), config);
  }
  //NOTIFICATIONS
  static async NOTIFICATIONS(params) {
    await this.getToken();
    return HttpService.get(`${API.NOTIFICATIONS}` + params, config);
  }
  static async MARK_SEEN(payload) {
    await this.getToken();
    const query = serialize(payload);
    return HttpService.put(`${API.MARK_SEEN}${query}`, {}, config);
  }
  static async MARK_ALL_SEEN(payload) {
    await this.getToken();
    return HttpService.put(`${API.MARK_ALL_SEEN}`, payload, config);
  }
  static async UNREAD() {
    await this.getToken();
    return HttpService.get(`${API.UNREAD}`, config);
  }

  //WALLET
  static async BALANCE() {
    await this.getToken();
    return HttpService.get(`${API.BALANCE}`, config);
  }
  static async TRANSACTIONS(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.TRANSACTIONS}${query}`, config);
  }
  static async TOKEN_LIMIT_REQUEST(payload) {
    await this.getToken();
    return HttpService.post(`${API.TOKEN_LIMIT_REQUEST}`, payload, config);
  }

  //Offboard
  static async OFFBOARD_CASHOUT(body) {
    await this.getToken();
    return HttpService.post(`${API.OFFBOARD_CASHOUT}`, body, config);
  }

  static async OFFBOARD_CASHOUT_LIST(body) {
    await this.getToken();
    return HttpService.post(`${API.OFFBOARD_CASHOUT_LIST}`, body, config);
  }

  static async OFFBOARD_CASHOUT_SEND(body) {
    await this.getToken();
    return HttpService.post(`${API.OFFBOARD_CASHOUT_SEND}`, body, config);
  }

  //Payment
  static async TIP_ARTIST(body) {
    await this.getToken();
    return HttpService.post(`${API.TIP_ARTIST}`, body, config);
  }
  static async TIP_PLAYLIST(body) {
    await this.getToken();
    return HttpService.post(`${API.TIP_PLAYLIST}`, body, config);
  }
  // GAMIFICATION;
  static async CURATOR_DATA(params) {
    await this.getToken();
    return HttpService.get(`${API.CURATOR_DATA}${params}`, config);
  }
  static async CREATOR_DATA(params) {
    await this.getToken();
    return HttpService.get(`${API.CREATOR_DATA}${params}`, config);
  }
  static async GLOBAL_LEADERBOARD(params) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.GLOBAL_LEADERBOARD}?${queryString}`, config);
  }

  // OPTIMIZED GAMIFICATION V2 - 5-10x FASTER
  static async GAMIFICATION_COMPLETE(userid) {
    await this.getToken();
    const queryString = userid ? `?userid=${userid}` : '';
    return HttpService.get(`${API.GAMIFICATION_COMPLETE}${queryString}`, config);
  }
  
  static async GAMIFICATION_CURATOR_V2(userid) {
    await this.getToken();
    const queryString = userid ? `?userid=${userid}` : '';
    return HttpService.get(`${API.GAMIFICATION_CURATOR_V2}${queryString}`, config);
  }
  
  static async GAMIFICATION_CREATOR_V2(userid) {
    await this.getToken();
    const queryString = userid ? `?userid=${userid}` : '';
    return HttpService.get(`${API.GAMIFICATION_CREATOR_V2}${queryString}`, config);
  }
  
  static async GLOBAL_LEADERBOARD_V2(params) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.GLOBAL_LEADERBOARD_V2}?${queryString}`, config);
  }
  
  static async LEADERBOARD_POSITION(userid, sortBy = 'totalPoints') {
    await this.getToken();
    const queryString = new URLSearchParams({ userid, sortBy }).toString();
    return HttpService.get(`${API.LEADERBOARD_POSITION}?${queryString}`, config);
  }
  static async TOPTEN_LISTEN_PLAYLIST() {
    await this.getToken();
    return HttpService.get(`${API.TOPTEN_LISTEN_PLAYLIST}`, config);
  }
  static async TOPTEN_TIP_PLAYLIST() {
    await this.getToken();
    return HttpService.get(`${API.TOPTEN_TIP_PLAYLIST}`, config);
  }
  static async TOPTEN_SAVED_PLAYLIST() {
    await this.getToken();
    return HttpService.get(`${API.TOPTEN_SAVED_PLAYLIST}`, config);
  }
  static async PLAYLIST_STATICS(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.PLAYLIST_STATICS}` + query, config);
  }

  // Feed
static async FETCH_MUSIC_FEED(params = "") {
  await this.getToken();
  const query = params ? `?${serialize(params)}` : "";
  return HttpService.get(`${API.FEED_MUSIC}${query}`, config);
}

static async FETCH_VIDEO_FEED(params = "") {
  await this.getToken();
  const query = params ? `?${serialize(params)}` : "";
  return HttpService.get(`${API.FEED_VIDEO}${query}`, config);
}

// Unified feed: music + videos + gallery images interleaved by post time.
static async FETCH_UNIFIED_FEED(params = "") {
  await this.getToken();
  const query = params ? `?${serialize(params)}` : "";
  return HttpService.get(`${API.FEED_ALL}${query}`, config);
}

  
  //Analytics
  static async MUSIC_ANALYTICS() {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_ANALYTICS}`, config);
  }
  static async LIFEIME_VIEW_ANALYTICS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFEIME_VIEW_ANALYTICS}${range}`, config);
  }
  static async LIFETIME_TIP_ANALYTICS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_TIP_ANALYTICS}${range}`, config);
  }
  static async LIFEIME_STREAM_ANALYTICS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFEIME_STREAM_ANALYTICS}${range}`, config);
  }
  static async LIFEIME_FOLLOWERS_ANALYTICS(range) {
    await this.getToken();
    return HttpService.get(
      `${API.LIFEIME_FOLLOWERS_ANALYTICS}${range}`,
      config
    );
  }
  static async MUSIC_VIEW_ANALYTICS(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_VIEW_ANALYTICS}${params}`, config);
  }
  static async MUSIC_TIP_ANALYTICS(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_TIP_ANALYTICS}${params}`, config);
  }
  static async MUSIC_STREAM_ANALYTICS(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_STREAM_ANALYTICS}${params}`, config);
  }
  static async MUSIC_FOLLOW_ANALYTICS(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_FOLLOW_ANALYTICS}${params}`, config);
  }
  static async AGE_GROUP(params) {
    await this.getToken();
    return HttpService.get(`${API.AGE_GROUP}${params}`, config);
  }
  static async COUNT(params) {
    await this.getToken();
    return HttpService.get(`${API.COUNT}${params}`, config);
  }

  //curator
  static async LIFETIME_TIPS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_TIPS}${range}`, config);
  }
  static async LIFETIME_LISTEN(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_LISTEN}${range}`, config);
  }
  static async LIFETIME_SUBSCRIPTION(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_SUBSCRIPTION}${range}`, config);
  }
  static async LIFETIME_OWNED(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_OWNED}${range}`, config);
  }
  static async LIFETIME_PURCHASE(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_PURCHASE}${range}`, config);
  }
  static async LIFETIME_PLAYLISTS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_PLAYLISTS}${range}`, config);
  }
  static async LIFETIME_STREAMS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_STREAMS}${range}`, config);
  }
  static async CURATOR_TAB_DATA(range) {
    await this.getToken();
    return HttpService.get(`${API.CURATOR_TAB_DATA}${range}`, config);
  }
  //CREATOR
  static async CREATOR_STREAMS(range) {
    await this.getToken();
    return HttpService.get(`${API.CREATOR_STREAMS}${range}`, config);
  }
  static async SONG_RELEASED(range) {
    await this.getToken();
    return HttpService.get(`${API.SONG_RELEASED}${range}`, config);
  }
  static async NFT_SOLD(range) {
    await this.getToken();
    return HttpService.get(`${API.NFT_SOLD}${range}`, config);
  }
  static async PLAYLIST_ADD(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_ADD}${range}`, config);
  }
  static async CREATOR_TAB_DATA(range) {
    await this.getToken();
    return HttpService.get(`${API.CREATOR_TAB_DATA}${range}`, config);
  }
  //HomeScreen

  //MUSIC
  static async MUSIC_ALL(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_ALL}`, config);
  }
  static async MUSIC_MOST_LISTEN(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_MOST_LISTEN}`, config);
  }
  static async MUSIC_MOST_STREAM_TODAY(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_MOST_STREAM_TODAY}`, config);
  }
  static async MUSIC_MOST_STREAM_WEEK(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_MOST_STREAM_WEEK}`, config);
  }
  static async MUSIC_NEW_RELEASE(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_NEW_RELEASE}`, config);
  }
  static async MUSIC_MOST_TIPPED(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_MOST_TIPPED}`, config);
  }
  static async MUSIC_TRENDING_TICKER() {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_TRENDING_TICKER}`, config);
  }

  //NFT
  static async NFT_ALL(range) {
    await this.getToken();
    return HttpService.get(`${API.NFT_ALL}`, config);
  }
  static async MOSTEXPENSIVE(range) {
    await this.getToken();
    return HttpService.get(`${API.MOSTEXPENSIVE}`, config);
  }
  static async PLAYLISTMOSTEXPENSIVE(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLISTMOSTEXPENSIVE}`, config);
  }
  static async LEASTEXPENSIVE(range) {
    await this.getToken();
    return HttpService.get(`${API.LEASTEXPENSIVE}`, config);
  }
  static async PLAYLISTLEASTEXPENSIVE(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLISTLEASTEXPENSIVE}`, config);
  }
  static async OWNERPERCENTAGE(range) {
    await this.getToken();
    return HttpService.get(`${API.OWNERPERCENTAGE}`, config);
  }
  static async ENDINGSOONAUCTION(range) {
    await this.getToken();
    return HttpService.get(`${API.ENDINGSOONAUCTION}`, config);
  }
  static async NFT_RANK(param) {
    await this.getToken();
    return HttpService.get(`${API.NFT_RANK}${param}`, config);
  }
  static async ACTIVE_BID(param) {
    await this.getToken();
    return HttpService.get(`${API.ACTIVE_BID}${param}`, config);
  }
  //PLAYLIST
  static async PLAYLIST_ALL(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_ALL}`, config);
  }
  static async PLAYLIST_MOST_TIPPED(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_MOST_TIPPED}`, config);
  }
  static async PLAYLIST_STREAMED(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_STREAMED}`, config);
  }
  static async PLAYLIST_NEW_RELEASE(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_NEW_RELEASE}`, config);
  }
  static async PLAYLIST_STREAMED_LASTWEEK(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_STREAMED_LASTWEEK}`, config);
  }
  static async PLAYLIST_MOST_STREAMED(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_MOST_STREAMED}`, config);
  }
  //STREAM
  static async STREAM_ADD(payload) {
    await this.getToken();
    return HttpService.post(`${API.STREAM_ADD}`, payload, config);
  }
  /** A filled AdSense slot: skpay pays the plays before it from the ad's (estimated) revenue. */
  static async AD_IMPRESSION(payload) {
    await this.getToken();
    return HttpService.post(API.AD_IMPRESSION, payload, config);
  }
  /** The next direct-sold ad for the song break, or `result: null` when there is none to show. */
  static async AD_NEXT() {
    await this.getToken();
    return HttpService.get(API.AD_NEXT, config);
  }
  /** The listener tapped the ad creative; links the click to its impression. */
  static async AD_CLICK(payload) {
    await this.getToken();
    return HttpService.post(API.AD_CLICK, payload, config);
  }
  static async ADMIN_GET_DIRECT_ADS(params = {}) {
    await this.getToken();
    return HttpService.get(API.ADMIN_ADS, { ...config, params });
  }
  static async ADMIN_UPLOAD_DIRECT_AD(formData) {
    await this.getToken();
    return HttpService.post(API.ADMIN_AD_UPLOAD, formData, {
      ...config,
      headers: { ...config.headers, "Content-Type": "multipart/form-data" },
    });
  }
  static async ADMIN_UPDATE_DIRECT_AD(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_AD_UPDATE, payload, config);
  }
  static async ADMIN_ORDER_DIRECT_ADS(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_AD_ORDER, payload, config);
  }
  static async ADMIN_GET_SPONSORS(params = {}) {
    await this.getToken();
    return HttpService.get(API.ADMIN_SPONSORS, { ...config, params });
  }
  static async ADMIN_CREATE_SPONSOR(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_SPONSOR, payload, config);
  }
  static async ADMIN_UPDATE_SPONSOR(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_SPONSOR_UPDATE, payload, config);
  }
  static async ADMIN_GET_SPONSORSHIP_PACKAGES(params = {}) {
    await this.getToken();
    return HttpService.get(API.ADMIN_SPONSORSHIP_PACKAGES, { ...config, params });
  }
  static async ADMIN_CREATE_SPONSORSHIP_PACKAGE(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_SPONSORSHIP_PACKAGE, payload, config);
  }
  static async ADMIN_UPDATE_SPONSORSHIP_PACKAGE(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_SPONSORSHIP_PACKAGE_UPDATE, payload, config);
  }
  static async ADMIN_GET_AD_CAMPAIGNS(params = {}) {
    await this.getToken();
    return HttpService.get(API.ADMIN_AD_CAMPAIGNS, { ...config, params });
  }
  static async ADMIN_CREATE_AD_CAMPAIGN(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_AD_CAMPAIGN, payload, config);
  }
  static async ADMIN_UPDATE_AD_CAMPAIGN(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_AD_CAMPAIGN_UPDATE, payload, config);
  }
  static async ADMIN_GET_AD_CAMPAIGN_REPORT(params) {
    await this.getToken();
    return HttpService.get(API.ADMIN_AD_CAMPAIGN_REPORT, { ...config, params });
  }
  static async ADMIN_CREATE_SPONSORSHIP_DEAL(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_SPONSORSHIP_DEAL, payload, config);
  }
  static async ADMIN_GET_PAYOUT_COVERAGE() {
    await this.getToken();
    return HttpService.get(API.ADMIN_PAYOUT_COVERAGE, config);
  }
  static async STREAM_START(payload) {
    await this.getToken();
    return HttpService.post(`${API.STREAM_START}`, payload, config);
  }
  static async STREAM_PAUSE(payload) {
    await this.getToken();
    return HttpService.post(`${API.STREAM_PAUSE}`, payload, config);
  }
  static async STREAM_HEARTBEAT(payload) {
    await this.getToken();
    return HttpService.post(`${API.STREAM_HEARTBEAT}`, payload, config);
  }
  static async STREAM_STOP(payload) {
    await this.getToken();
    return HttpService.post(`${API.STREAM_STOP}`, payload, config);
  }

  //Public
  static async CHARGES() {
    await this.getToken();
    return HttpService.get(`${API.CHARGES}`, config);
  }
  //BANNER;
  static async BANNER() {
    await this.getToken();
    return HttpService.get(`${API.BANNER}`, config);
  }

  //Chat:
  static async GET_MESSAGES() {
    await this.getToken();
    return HttpService.get(`${API.GET_MESSAGES}`, config);
  }
  static async GET_PLAYLIST_TOP_FIVE(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_PLAYLIST_TOP_FIVE}${params}`, config);
  }
  static async GET_PLAYLIST_MOST_TIPPED(params) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_TOP_MOST_TIPPED}${params}`, config);
  }
  static async GET_PLAYLIST_MOST_STREAMED(params) {
    await this.getToken();
    return HttpService.get(
      `${API.PLAYLIST_TOP_MOST_STREAMED}${params}`,
      config
    );
  }
  static async GET_TOP_CHATS(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_TOP_CHATS}${params}`, config);
  }
  static async GET_PRIVATE_MESSAGE(params) {
    await this.getToken();
    const param = serialize(params);
    return HttpService.get(`${API.GET_PRIVATE_MESSAGE}${param}`, config);
  }
  static async READ_MESSAGE(params) {
    await this.getToken();
    const param = serialize(params);
    return HttpService.put(`${API.READ_MESSAGE}${param}`, {}, config);
  }

  static async GROUP_CHAT(params) {
    await this.getToken();

    return HttpService.get(`${API.GROUP_CHAT}${params}`, config);
  }
  static async GROUP_CHAT_V2(params) {
    await this.getToken();
    const url = `${API.GROUP_CHAT_V2}${params}`;
    console.log('[API Service] GROUP_CHAT_V2 request', { url, params });

    const startTime = performance.now();
    try {
      const response = await HttpService.get(url, config);
      console.log('[API Service] GROUP_CHAT_V2 response', {
        duration: performance.now() - startTime,
        hasResult: !!response?.result
      });
      return response;
    } catch (error) {
      console.error('[API Service] GROUP_CHAT_V2 error', {
        duration: performance.now() - startTime,
        error: error.message,
        status: error.response?.status
      });
      throw error;
    }
  }

  static async GET_PLAYLIST_MESSAGE(params) {
    await this.getToken();
    const param = serialize(params);
    return HttpService.get(`${API.GET_PLAYLIST_MESSAGE}${param}`, config);
  }
  static async BLOCK_USER_CHAT(body) {
    await this.getToken();
    return HttpService.put(`${API.BLOCK_USER_CHAT}`, body, config);
  }
  // Studio owner wipes the studio chat: { playlistId }.
  static async CLEAR_PLAYLIST_CHAT(body) {
    await this.getToken();
    return HttpService.post(`${API.CLEAR_PLAYLIST_CHAT}`, body, config);
  }
  // Either member wipes a direct chat: { roomId } or { userId }.
  static async CLEAR_DIRECT_CHAT(body) {
    await this.getToken();
    return HttpService.post(`${API.CLEAR_DIRECT_CHAT}`, body, config);
  }
  // { subscribersOnly, eligible, subscriptionsEnabled, active }
  static async DM_SETTINGS_GET() {
    await this.getToken();
    return HttpService.get(API.DM_SETTINGS, config);
  }
  static async DM_SETTINGS_PUT({ subscribersOnly }) {
    await this.getToken();
    config.headers["Content-Type"] = "application/json";
    return HttpService.put(API.DM_SETTINGS, { subscribersOnly }, config);
  }
  // { allowed: true } | { allowed: false, reason: "SUBSCRIBERS_ONLY", recipientId }
  static async DM_ACCESS(userId) {
    await this.getToken();
    return HttpService.get(`${API.DM_ACCESS}${encodeURIComponent(userId)}`, config);
  }
  static async BLOCKER_USER(params) {
    await this.getToken();
    return HttpService.get(`${API.BLOCKER_USER}${params}`, config);
  }
  static async GET_ROOM_ID(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_ROOM_ID}${params}`, config);
  }

  //Auction House

  static async BID_LIST(params) {
    await this.getToken();
    return HttpService.get(`${API.BID_LIST}${params}`, config);
  }
  static async AUCTION_LIST(params) {
    await this.getToken();
    return HttpService.get(`${API.AUCTION_LIST}${params}`, config);
  }
  static async BID_AND_AUCTIONS() {
    await this.getToken();
    return HttpService.get(`${API.BID_AND_AUCTIONS}`, config);
  }
  static async OFFERS(param) {
    await this.getToken();
    return HttpService.get(`${API.OFFERS}${param}`, config);
  }
  static async ACTIVITY(param) {
    await this.getToken();
    return HttpService.get(`${API.ACTIVITY}${param}`, config);
  }
  static async OFFERS_PLAYLIST(param) {
    await this.getToken();
    return HttpService.get(`${API.OFFERS_PLAYLIST}${param}`, config);
  }
  static async ACTIVITY_PLAYLIST(param) {
    await this.getToken();
    return HttpService.get(`${API.ACTIVITY_PLAYLIST}${param}`, config);
  }

  //OFFERS
  static async OFFERS_SALE(param) {
    await this.getToken();
    return HttpService.get(`${API.OFFERS_SALE}${param}`, config);
  }
  static async OFFERS_AUCTION(param) {
    await this.getToken();
    return HttpService.get(`${API.OFFERS_AUCTION}${param}`, config);
  }

  //Streaming
  static async TOP_TIPPERS(param) {
    await this.getToken();
    return HttpService.get(`${API.TOP_TIPPERS}${param}`, config);
  }
  static async GOAL(param) {
    await this.getToken();
    return HttpService.get(`${API.GOAL}${param}`, config);
  }
  static async LIVESTREAM(param) {
    await this.getToken();
    return HttpService.get(`${API.LIVESTREAM}${param ? param : ""}`, config);
  }
 // Start a livestream
 static async LIVESTART(body) {
  await this.getToken();
  return HttpService.post(API.LIVESTART, body, config);
}

 // Start a livestream
 static async LIVEEXIT(body) {
  await this.getToken();
  return HttpService.post(API.LIVEEXIT, body, config);
}

// End a livestream
static async LIVEEND(body) {
  await this.getToken();
  return HttpService.post(API.LIVEEND, body, config);
}

// Join a livestream
static async LIVEJOIN(body) {
  await this.getToken();
  console.log("LIVEJOIN URL =>", API.LIVEJOIN);

  return HttpService.post(API.LIVEJOIN, body, config);
}

// Renew the Agora token for the current channel; the server derives the role
static async LIVE_TOKEN_RENEW(body) {
  await this.getToken();
  return HttpService.post(API.LIVE_TOKEN_RENEW, body, config);
}

// Admin: investor profit-breakdown pages (admin-only on the API)
static async PROFIT_BREAKDOWN_LIST() {
  await this.getToken();
  return HttpService.get(API.PROFIT_BREAKDOWN, config);
}

static async PROFIT_BREAKDOWN_CREATE(body) {
  await this.getToken();
  return HttpService.post(API.PROFIT_BREAKDOWN, body, config);
}

static async PROFIT_BREAKDOWN_UPDATE(id, body) {
  await this.getToken();
  return HttpService.put(`${API.PROFIT_BREAKDOWN}/${id}`, body, config);
}

static async PROFIT_BREAKDOWN_DELETE(id) {
  await this.getToken();
  return HttpService.delete(`${API.PROFIT_BREAKDOWN}/${id}`, config);
}

static async PROFIT_BREAKDOWN_TOGGLE_ACTIVE(id) {
  await this.getToken();
  return HttpService.patch(`${API.PROFIT_BREAKDOWN}/${id}/toggle-active`, {}, config);
}

  static async LAYOUT(param) {
    await this.getToken();
    return HttpService.post(`${API.LAYOUT}${param}`, {}, config);
  }

  //MATIC

  static async CREATE_MATIC(param) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_MATIC}${param}`, {}, config);
  }

  //VIDEO

  static async FEATURE_VIDEO(params) {
    await this.getToken();
    // Use the dedicated featured videos endpoint
    return HttpService.get(`${API.FEATURE_VIDEO}?${params}`, config);
  }

  static async SEARCH_VIDEO(keyword) {
    await this.getToken();
    const params = serialize(keyword);
    return HttpService.get(`${API.VIDEO_SEARCH}?${params}`, config);
  }

  static async UPLOAD_VIDEO(payload) {
    await this.getToken();
    return HttpService.post(`${API.VIDEO}`, payload, config);
  }
  static async VIDEO_BY_UPLOADER(uploaderId) {
  await this.getToken();
  // Ensure uploaderId is provided
  if (!uploaderId) throw new Error("uploaderId is required");
  // Compose the full URL
  const url = `${API.VIDEO_BY_UPLOADER}${uploaderId}`;
  console.log("VIDEO_BY_UPLOADER URL:", url);
  return HttpService.get(url, config);
}

// Update video with studioId, videoId, and formData
static async UPDATEVIDEO({ studioId, videoId, formData }) {
  await this.getToken();
  
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: cookieStorage.getCookie("Authorization"),
    },
  };

  const updateUrl = `${API.UPDATEVIDEO.replace(':studioId', studioId).replace(':videoId', videoId)}`;
  return HttpService.put(updateUrl, formData, config);
}

// Delete video with studioId and videoId
static async deleteUserVideo(studioId, videoId) {
  await this.getToken();
  
  const config = {
    headers: {
      Authorization: cookieStorage.getCookie("Authorization"),
    },
  };

  const deleteUrl = `${API.DELETE_VIDEO.replace(':studioId', studioId).replace(':videoId', videoId)}`;
  return HttpService.delete(deleteUrl, config);
}

  

  static async VIDEO_USER(studioId) {
    await this.getToken();
    
    // Dynamically replace `:studioId` with the actual `studioId`
    const getvidUrl = `${API.VIDEO_USER.replace(':studioId', studioId)}`;
  
    // Fetch the videos
    return HttpService.get(getvidUrl, config);
  }
  

static async UPVID(studioId, formData, { onUploadProgress } = {}) {
  await this.getToken();
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: cookieStorage.getCookie("Authorization"),
    },
    timeout: 600000, // 10 minutes for video uploads
    ...(onUploadProgress && { onUploadProgress }),
  };
  const uploadUrl = `${API.UPVID.replace(':studioId', studioId)}`;

  return HttpService.post(uploadUrl, formData, config);
}


static async deleteUserVideo(studioId, videoId) {
  await this.getToken(); 
  const config = {
 
    headers: {
      Authorization: cookieStorage.getCookie("Authorization"),
  }
};
  const deleteUrl = `${API.DELETE_VIDEO.replace(':studioId', studioId).replace(':videoId', videoId)}`;
  return HttpService.delete(deleteUrl, config);
}



  static async GET_VIDEOS(params) {
    await this.getToken();
    return HttpService.get(`${API.VIDEO}${params}`, config);
  }
  static async D_VIDEOS(params) {
    await this.getToken();
    return HttpService.get(`${API.DOWNLOAD_RECORDING}${params}`, config);
  }

  //Recordings
  static async RECORDINGS(params) {
    await this.getToken();
    return HttpService.get(`${API.RECORDINGS}${params}`, config);
  }

  static async CREATE_CLIP(payload) {
    await this.getToken();
    return HttpService.post(API.CREATE_CLIP, payload, config);
  }

  static async UPLOAD_CLIP(formData) {
    await this.getToken();
    return HttpService.post(API.UPLOAD_CLIP, formData, {
      ...config,
      headers: { ...config.headers, 'Content-Type': 'multipart/form-data' },
    });
  }

  static async VIEW_CLIP(clipId) {
    await this.getToken();
    return HttpService.post(`${API.VIEW_CLIP}/${clipId}/view`, {}, config);
  }

  static async GET_STREAM_CLIPS(livestreamId) {
    await this.getToken();
    return HttpService.get(`${API.STREAM_CLIPS}/${livestreamId}`, config);
  }

  static async GET_USER_CLIPS() {
    await this.getToken();
    return HttpService.get(API.USER_CLIPS, config);
  }

  static async DELETE_CLIP(clipId) {
    await this.getToken();
    return HttpService.delete(`${API.DELETE_CLIP}/${clipId}`, config);
  }

  static async deleteRecording(recordingId) {
    await this.getToken();
  
    const deleteUrl = `${API.DELETE_RECORDING.replace(':recordingId', recordingId)}`;
    console.log("Delete Recording URL:", deleteUrl);
  
    return HttpService.delete(deleteUrl, config);
  }
// ApiService.js

static async updateRecording(recordingId, formData) {
  await this.getToken();

  // Check if `recordingId` is provided
  if (!recordingId) {
    throw new Error("Recording ID is missing for update.");
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: cookieStorage.getCookie("Authorization"),
    },
  };

  // Replace `:recordingId` with the actual recording ID
  const updateUrl = `${API.UPDATE_RECORDING.replace(':recordingId', recordingId)}`;
  console.log("Update Recording URL:", updateUrl);

  // Make sure to use `FormData` for the request payload
  return HttpService.put(updateUrl, formData, config);
}

static async uploadRecording(formData, onUploadProgress) {
  await this.getToken();

  const token = cookieStorage.getCookie("Authorization");
  const uploadConfig = {
    headers: {
      // Don't set Content-Type - let axios set it automatically with boundary for FormData
      Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`,
    },
  };

  // Add upload progress callback if provided
  if (onUploadProgress) {
    uploadConfig.onUploadProgress = onUploadProgress;
  }

  return HttpService.post(API.UPLOAD_RECORDING, formData, uploadConfig);
}


  //language
  static async LANGUAGE(params) {
    await this.getToken();
    return HttpService.get(`${API.LANGUAGE}${params}`, config);
  }
  //Update gift
  static async updatGiftStatus(payload) {
    await this.getToken();
    return HttpService.post(`${API.UPDATE_GIFT_STATUS}`, payload, config);
  }
  //Add count
  static async ADD_COUNT() {
    await this.getToken();
    return HttpService.get(`${API.ADD_COUNT}`, config);
  }
  //Add
  static async ADD(params) {
    await this.getToken();
    return HttpService.get(`${API.ADD}${params}`, config);
  }

  //Trending music
  static async TRENDING(params) {
    await this.getToken();
    return HttpService.get(`${API.TRENDING}${params}`, config);
  }

  static async TOP_ALBUM_MUSIC_STUDIO_LIST(keyword) {
    const start = performance.now();
    await this.getToken();
    const query = serialize(keyword);
    const result = await HttpService.get(`${API.TOP_LIST}` + query, config);
    console.log(`TOP_ALBUM_MUSIC_STUDIO_LIST API took ${performance.now() - start}ms`);
    return result;
  }

  static async MUSIC_LIST(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.MUSIC_LIST}` + query, config);
  }

  // Artist Search
  static async SEARCH_ARTIST(keyword) {
    await this.getToken();
    return HttpService.get(`${API.SEARCH_ARTIST}` + keyword, config);
  }

  // Elastic Search
  static async SEARCH(keyword) {
    await this.getToken();
    return HttpService.get(
      `${API.SEARCH}` + encodeURIComponent(keyword),
      config
    );
  }

  // schedule livestream
  static async SCHEDULE_LIVESTREAM(payload) {
    await this.getToken();
    return HttpService.post(`${API.SCHEDULE_LIVESTREAM}`, payload, config);
  }

  // schedule livestream cancel
  static async SCHEDULE_LIVESTREAM_CANCEL(keyword) {
    await this.getToken();
    return HttpService.post(`${API.SCHEDULE_LIVESTREAM_CANCEL}`, payload, config);
  }

  // schedule livestreams
  static async SCHEDULE_LIVESTREAMS(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.SCHEDULE_LIVESTREAMS}` + query, config);
  }

  // schedule livestreams date
  static async SCHEDULE_LIVESTREAMS_DATE(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.SCHEDULE_LIVESTREAMS_DATE}` + query, config);
  }

  // schedule livestreams user
  static async SCHEDULE_LIVESTREAMS_USER(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.SCHEDULE_LIVESTREAMS_USER}` + query, config);
  }

  // Dynamic Link
  static async CREATE_DYNAMIC_LINK(payload) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_DYNAMIC_LINK}`, payload, config);
  }

  // Banner Management
  static async GET_MEDIA_BANNERS() {
    await this.getToken();
    return HttpService.get(API.BANNER, config);
  }

  // Admin view: returns ALL banners including hidden ones (so they can be shown
  // again). The public GET_MEDIA_BANNERS filters hidden banners out.
  static async ADMIN_GET_BANNERS() {
    await this.getToken();
    return HttpService.get(API.ADMIN_BANNERS, config);
  }

  static async UPLOAD_BANNER(formData) {
    await this.getToken();
    const uploadConfig = {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
    return HttpService.post(API.ADMIN_UPLOAD_BANNER, formData, uploadConfig);
  }

  static async DELETE_BANNERS(payload) {
    await this.getToken();
    const deleteConfig = {
      ...config,
      data: payload // For DELETE requests with body
    };
    return HttpService.delete(API.ADMIN_DELETE_BANNERS, deleteConfig);
  }

  static async TOGGLE_BANNER_VISIBILITY(payload) {
    await this.getToken();
    return HttpService.patch(API.ADMIN_TOGGLE_BANNER_VISIBILITY, payload, config);
  }

  // PowerPlays Management
  static async GET_POWERPLAYS() {
    await this.getToken();
    return HttpService.get(API.POWERPLAYS, config);
  }

  static async ADMIN_GET_POWERPLAYS() {
    await this.getToken();
    return HttpService.get(API.ADMIN_POWERPLAYS, config);
  }

  static async GET_POWERPLAY_METRICS() {
    await this.getToken();
    return HttpService.get(`${API.ADMIN_POWERPLAYS}/metrics`, config);
  }

  static async GET_POWERPLAY_LEADERBOARD(id) {
    await this.getToken();
    return HttpService.get(`${API.POWERPLAYS}/${id}/leaderboard`, config);
  }

  static async CREATE_POWERPLAY(data) {
    await this.getToken();
    return HttpService.post(API.ADMIN_POWERPLAYS, data, config);
  }

  static async UPDATE_POWERPLAY(id, data) {
    await this.getToken();
    return HttpService.put(`${API.ADMIN_POWERPLAYS}/${id}`, data, config);
  }

  static async DELETE_POWERPLAY(id) {
    await this.getToken();
    return HttpService.delete(`${API.ADMIN_POWERPLAYS}/${id}`, config);
  }

  static async UPLOAD_POWERPLAY_IMAGE(formData) {
    await this.getToken();
    const uploadConfig = {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
    return HttpService.post(API.POWERPLAYS_UPLOAD, formData, uploadConfig);
  }

  static async UPLOAD_IMAGE(formData) {
    await this.getToken();
    const uploadConfig = {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
    return HttpService.post(API.ADMIN_UPLOAD_BANNER, formData, uploadConfig);
  }

  static async GET_MLC_REPORT(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${SERVER_URL}/admin/mlc?${query}`, config);
  }

  // Generic HTTP methods
  static async get(url, params = {}) {
    await this.getToken();
    const query = Object.keys(params).length ? serialize(params) : '';
    const fullUrl = url.startsWith('/') ? `${SERVER_URL}${url}` : url;
    return HttpService.get(`${fullUrl}${query}`, config);
  }

  static async post(url, payload) {
    await this.getToken();
    const fullUrl = url.startsWith('/') ? `${SERVER_URL}${url}` : url;
    return HttpService.post(fullUrl, payload, config);
  }

  static async put(url, payload) {
    await this.getToken();
    const fullUrl = url.startsWith('/') ? `${SERVER_URL}${url}` : url;
    return HttpService.put(fullUrl, payload, config);
  }

  static async delete(url) {
    await this.getToken();
    const fullUrl = url.startsWith('/') ? `${SERVER_URL}${url}` : url;
    return HttpService.delete(fullUrl, config);
  }
  
  // Admin Balance Management
  static async getAllBalances(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_GET_ALL_BALANCES}?${queryString}`, config);
  }
  
  static async getUserBalanceDetails(userId) {
    await this.getToken();
    return HttpService.get(`${API.ADMIN_GET_USER_BALANCE_DETAILS}/${userId}`, config);
  }
  
  static async modifyUserBalance(userId, data) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_MODIFY_USER_BALANCE}/${userId}/modify`, data, config);
  }
  
  static async releaseLock(userId, lockId) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_RELEASE_LOCK}/${userId}/release-lock`, { lockId }, config);
  }
  
  static async reconcileBalance(userId) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_RECONCILE_BALANCE}/${userId}/reconcile`, {}, config);
  }
  
  // Token Transfer Methods
  static async transferTokens(data) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_TRANSFER_TOKENS}`, data, config);
  }
  
  static async transferToExternalWallet(data) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_TRANSFER_EXTERNAL}`, data, config);
  }
  
  static async getTransferHistory(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_TRANSFER_HISTORY}?${queryString}`, config);
  }
  
  static async getAvailableWallets(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_AVAILABLE_WALLETS}?${queryString}`, config);
  }

  static async getWalletHistory(userId) {
    await this.getToken();
    return HttpService.get(`${API.ADMIN_GET_WALLET_HISTORY}/${userId}`, config);
  }

  static async getRecentWalletChanges(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_GET_WALLET_CHANGES}?${queryString}`, config);
  }

  static async ADMIN_CLEAR_LIVESTREAM_TIMESTAMPS(payload) {
    await this.getToken();
    return HttpService.post(API.ADMIN_CLEAR_LIVESTREAM_TIMESTAMPS, payload, config);
  }

  // Song Request APIs
  static async SONG_REQUEST_SUBMIT(data) {
    await this.getToken();
    return HttpService.post(`${API.SONG_REQUEST_SUBMIT}`, data, config);
  }

  static async SONG_REQUEST_LIST(roomId) {
    await this.getToken();
    return HttpService.get(`${API.SONG_REQUEST_LIST}/${roomId}`, config);
  }

  static async SONG_REQUEST_MINE(limit) {
    await this.getToken();
    const url = limit ? `${API.SONG_REQUEST_MINE}?limit=${limit}` : API.SONG_REQUEST_MINE;
    return HttpService.get(url, config);
  }

  static async SONG_REQUEST_HOST_PENDING() {
    await this.getToken();
    return HttpService.get(API.SONG_REQUEST_HOST_PENDING, config);
  }

  // The authenticated host's own tier config.
  static async SONG_REQUEST_GET_CONFIG() {
    await this.getToken();
    return HttpService.get(API.SONG_REQUEST_CONFIG, config);
  }

  // Update the authenticated host's tier config.
  static async SONG_REQUEST_UPDATE_CONFIG(data) {
    await this.getToken();
    return HttpService.put(API.SONG_REQUEST_CONFIG, data, config);
  }

  // Public: a host's tier config (prices + mode) for the requester modal.
  static async SONG_REQUEST_HOST_CONFIG(hostId) {
    await this.getToken();
    return HttpService.get(`${API.SONG_REQUEST_CONFIG}/${hostId}`, config);
  }

  // Public, no sign-in needed: one jukebox day behind a share link.
  static async SONG_REQUEST_JUKEBOX_DAY(hostId, slotId) {
    await this.getToken();
    return HttpService.get(
      `${API.SONG_REQUEST_JUKEBOX_DAY}/${encodeURIComponent(hostId)}/${encodeURIComponent(slotId)}`,
      config
    );
  }

  // The signed-in host's jukebox days with submission counts by status.
  static async SONG_REQUEST_HOST_DAYS() {
    await this.getToken();
    return HttpService.get(API.SONG_REQUEST_HOST_DAYS, config);
  }

  // One of the host's days ("unscheduled" for requests without one), newest first.
  static async SONG_REQUEST_HOST_DAY(slotId, { limit, cursor } = {}) {
    await this.getToken();
    const params = new URLSearchParams();
    if (limit) params.set("limit", String(limit));
    if (cursor) params.set("cursor", cursor);
    const query = params.toString();
    return HttpService.get(
      `${API.SONG_REQUEST_HOST_DAY}/${encodeURIComponent(slotId)}${query ? `?${query}` : ""}`,
      config
    );
  }

  // Public: a host's live pending queue (positions + tiers/amounts).
  static async SONG_REQUEST_QUEUE(hostId) {
    await this.getToken();
    return HttpService.get(`${API.SONG_REQUEST_QUEUE}/${hostId}`, config);
  }

  // The authenticated host's song-request earnings + activity summary.
  static async SONG_REQUEST_EARNINGS() {
    await this.getToken();
    return HttpService.get(API.SONG_REQUEST_EARNINGS, config);
  }

  static async SONG_REQUEST_ACCEPT(requestId) {
    await this.getToken();
    return HttpService.post(`${API.SONG_REQUEST_ACCEPT}/${requestId}`, {}, config);
  }

  static async SONG_REQUEST_REJECT(requestId) {
    await this.getToken();
    return HttpService.post(`${API.SONG_REQUEST_REJECT}/${requestId}`, {}, config);
  }

  static async SONG_REQUEST_CLEAR(roomId) {
    await this.getToken();
    return HttpService.delete(`${API.SONG_REQUEST_CLEAR}/${roomId}`, config);
  }

  static async SONG_REQUEST_ACCEPTED_LIST(roomId) {
    await this.getToken();
    return HttpService.get(`${API.SONG_REQUEST_ACCEPTED_LIST}/${roomId}`, config);
  }

  static async SONG_REQUEST_MARK_PLAYED(requestId) {
    await this.getToken();
    return HttpService.post(`${API.SONG_REQUEST_MARK_PLAYED}/${requestId}`, {}, config);
  }

  // Feedback Hub API methods
  static async FEEDBACK_CREATE(payload) {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/feedback`, payload, config);
  }

  static async FEEDBACK_GET_ALL() {
    await this.getToken();
    return HttpService.get(`${SERVER_URL}/feedback`, config);
  }

  static async FEEDBACK_DELETE(feedbackId) {
    await this.getToken();
    return HttpService.delete(`${SERVER_URL}/feedback/${feedbackId}`, config);
  }

  static async FEEDBACK_UPDATE_STATUS(feedbackId, status) {
    await this.getToken();
    return HttpService.put(`${SERVER_URL}/feedback/${feedbackId}/status`, { status }, config);
  }

  static async FEEDBACK_VOTE(feedbackId, type) {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/feedback/${feedbackId}/vote`, { type }, config);
  }

  // PayPal Subscription methods
  static async CREATE_PAYPAL_SUBSCRIPTION(payload) {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/paypal-subscription/create`, payload, config);
  }

  static async CANCEL_PAYPAL_SUBSCRIPTION(subscriptionId) {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/paypal-subscription/cancel`, { subscriptionId }, config);
  }

  static async VERIFY_PAYPAL_SUBSCRIPTION() {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/paypal-subscription/verify`, {}, config);
  }

  static async GET_PREMIUM_STATS() {
    await this.getToken();
    return HttpService.get(`${SERVER_URL}/admin/premium-stats`, config);
  }

  static async SYNC_SUBSCRIPTIONS() {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/admin/sync-subscriptions`, {}, config);
  }

  // Stripe Subscription methods (Apple Pay)
  static async CREATE_STRIPE_CHECKOUT(payload) {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/stripe-subscription/create-checkout-session`, payload, config);
  }

  static async CANCEL_STRIPE_SUBSCRIPTION(subscriptionId) {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/stripe-subscription/cancel/${subscriptionId}`, {}, config);
  }

  static async GET_STRIPE_SUBSCRIPTION(subscriptionId) {
    await this.getToken();
    return HttpService.get(`${SERVER_URL}/stripe-subscription/details/${subscriptionId}`, config);
  }

  // Stream Keys (OBS Streaming)
  static async STREAM_KEYS_STATUS() {
    await this.getToken();
    return HttpService.get(API.STREAM_KEYS_STATUS, config);
  }

  static async STREAM_KEYS_LIST(params = {}) {
    await this.getToken();
    const query = Object.keys(params).length ? `?${serialize(params)}` : '';
    return HttpService.get(`${API.STREAM_KEYS}${query}`, config);
  }

  static async STREAM_KEYS_CREATE(payload) {
    await this.getToken();
    return HttpService.post(API.STREAM_KEYS, payload, config);
  }

  static async STREAM_KEYS_GET_CONFIG(keyId) {
    await this.getToken();
    return HttpService.get(`${API.STREAM_KEYS}/${keyId}/config`, config);
  }

  static async STREAM_KEYS_REVOKE(keyId) {
    await this.getToken();
    return HttpService.delete(`${API.STREAM_KEYS}/${keyId}`, config);
  }

  // Livestream moderators: the host's trusted list (jukebox, songs, kicks).
  static async LIVESTREAM_MODERATORS_LIST() {
    await this.getToken();
    return HttpService.get(API.LIVESTREAM_MODERATORS, config);
  }

  static async LIVESTREAM_MODERATORS_STATUS(channelName) {
    await this.getToken();
    return HttpService.get(`${API.LIVESTREAM_MODERATORS}/status?channelName=${encodeURIComponent(channelName)}`, config);
  }

  static async LIVESTREAM_MODERATOR_ADD(userId, channelName) {
    await this.getToken();
    return HttpService.post(API.LIVESTREAM_MODERATORS, { userId, channelName }, config);
  }

  static async LIVESTREAM_MODERATOR_REMOVE(userId, channelName) {
    await this.getToken();
    const query = channelName ? `?channelName=${encodeURIComponent(channelName)}` : '';
    return HttpService.delete(`${API.LIVESTREAM_MODERATORS}/${userId}${query}`, config);
  }

  // Removes someone from a livestream. The API allows the host and moderators.
  static async LIVESTREAM_KICK(channelName, userId) {
    await this.getToken();
    return HttpService.post(API.LIVESTREAM_FORCE_DISCONNECT, { channelName, userId, reason: 'kicked' }, config);
  }

  static async STREAM_KEYS_START_LIVESTREAM(payload) {
    await this.getToken();
    return HttpService.post(API.STREAM_KEYS_START_LIVESTREAM, payload, config);
  }

  static async STREAM_KEYS_END_LIVESTREAM(payload) {
    await this.getToken();
    return HttpService.post(API.STREAM_KEYS_END_LIVESTREAM, payload, config);
  }

  // OBS Plugin API Keys
  static async OBS_API_KEY_GET() {
    await this.getToken();
    return HttpService.get(API.OBS_API_KEY, config);
  }

  static async OBS_API_KEY_GENERATE() {
    await this.getToken();
    return HttpService.post(API.OBS_API_KEY_GENERATE, {}, config);
  }

  static async OBS_API_KEY_REVOKE() {
    await this.getToken();
    return HttpService.delete(API.OBS_API_KEY, config);
  }

  // Prospecting
  static async PROSPECT_GET_LEADS(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.PROSPECT_LEADS}${queryString ? '?' + queryString : ''}`, config);
  }

  static async PROSPECT_GET_STATS() {
    await this.getToken();
    return HttpService.get(API.PROSPECT_STATS, config);
  }

  static async PROSPECT_GET_ACTIONS(limit = 20) {
    await this.getToken();
    return HttpService.get(`${API.PROSPECT_ACTIONS}?limit=${limit}`, config);
  }

  static async PROSPECT_GET_FOLLOWUPS(days = 3) {
    await this.getToken();
    return HttpService.get(`${API.PROSPECT_FOLLOWUPS}?days=${days}`, config);
  }

  static async PROSPECT_GET_INVESTORS() {
    await this.getToken();
    return HttpService.get(API.PROSPECT_INVESTORS, config);
  }

  static async PROSPECT_GET_EMAILS(type = 'artist') {
    await this.getToken();
    return HttpService.get(`${API.PROSPECT_EMAILS}?type=${type}`, config);
  }

  static async PROSPECT_LOG_ACTION(leadId, action, note) {
    await this.getToken();
    return HttpService.post(`${API.PROSPECT_ACTION}/${leadId}`, { action, note }, config);
  }

  static async PROSPECT_UPDATE_STATUS(leadId, status) {
    await this.getToken();
    return HttpService.post(`${API.PROSPECT_STATUS}/${leadId}`, { status }, config);
  }

  static async PROSPECT_ARCHIVE(leadId) {
    await this.getToken();
    return HttpService.post(`${API.PROSPECT_ARCHIVE}/${leadId}`, {}, config);
  }

  static async PROSPECT_BULK_ACTION(ids, action, note) {
    await this.getToken();
    return HttpService.post(API.PROSPECT_BULK_ACTION, { ids, action, note }, config);
  }

  // Admin Dashboard
  static async GAMIFICATION_PERFORMANCE_SUMMARY() {
    await this.getToken();
    return HttpService.get(API.GAMIFICATION_PERFORMANCE_SUMMARY, config);
  }

  static async GAMIFICATION_DASHBOARD() {
    await this.getToken();
    return HttpService.get(API.GAMIFICATION_DASHBOARD, config);
  }

  static async GAMIFICATION_METRICS_HISTORICAL(type = 'responseTime', hours = 24) {
    await this.getToken();
    return HttpService.get(`${API.GAMIFICATION_METRICS_HISTORICAL}?type=${type}&hours=${hours}`, config);
  }

  static async ADMIN_GET_ROYALTIES(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_GET_ROYALTIES}?${queryString}`, config);
  }

  static async ADMIN_GET_LIVESTREAM_HISTORY(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_GET_LIVESTREAM_HISTORY}?${queryString}`, config);
  }

  static async ADMIN_ADOPTION_METRICS() {
    await this.getToken();
    return HttpService.get(API.ADMIN_ADOPTION_METRICS, config);
  }

  static async ADMIN_GET_REFERRALS() {
    await this.getToken();
    return HttpService.get(API.ADMIN_REFERRALS, config);
  }

  static async CREATE_SHARE_LINK(payload) {
    await this.getToken();
    return HttpService.post(API.CREATE_SHARE_LINK, payload, config);
  }

  // Ticketing — User-facing
  static async TICKETING_GET_EVENTS(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.TICKETING_EVENTS}${queryString ? '?' + queryString : ''}`, config);
  }

  static async TICKETING_GET_EVENT(eventId) {
    await this.getToken();
    return HttpService.get(`${API.TICKETING_EVENT}/${eventId}`, config);
  }

  static async TICKETING_CREATE_EVENT(payload, coverImgFile) {
    await this.getToken();
    if (coverImgFile) {
      const formData = new FormData();
      formData.append('coverImg', coverImgFile);
      Object.entries(payload).forEach(([key, value]) => {
        formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
      });
      const formConfig = { ...config, headers: { ...config.headers, 'Content-Type': 'multipart/form-data' } };
      return HttpService.post(API.TICKETING_EVENT, formData, formConfig);
    }
    return HttpService.post(API.TICKETING_EVENT, payload, config);
  }

  static async TICKETING_PUBLISH_EVENT(eventId) {
    await this.getToken();
    return HttpService.post(`${API.TICKETING_EVENT}/${eventId}/publish`, {}, config);
  }

  static async TICKETING_GET_MY_EVENTS() {
    await this.getToken();
    return HttpService.get(API.TICKETING_MY_EVENTS, config);
  }

  static async TICKETING_PURCHASE_TICKET(payload) {
    await this.getToken();
    return HttpService.post(API.TICKETING_PURCHASE, payload, config);
  }

  static async TICKETING_GET_MY_TICKETS() {
    await this.getToken();
    return HttpService.get(API.TICKETING_MY_TICKETS, config);
  }

  static async TICKETING_GET_TICKET(ticketId) {
    await this.getToken();
    return HttpService.get(`${API.TICKETING_TICKET}/${ticketId}`, config);
  }

  static async TICKETING_GET_TICKET_QR(ticketId, deviceFingerprint) {
    await this.getToken();
    const token = config.headers.Authorization;
    const response = await fetch(`${API.TICKETING_TICKET}/${ticketId}/qr?deviceFingerprint=${encodeURIComponent(deviceFingerprint)}`, {
      headers: {
        'Authorization': token,
        'x-device-fingerprint': deviceFingerprint,
      },
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({ error: 'Failed to fetch QR' }));
      throw new Error(err.error || 'Failed to fetch QR code');
    }
    const blob = await response.blob();
    return { blob, timeWindow: response.headers.get('X-QR-Period') || '15' };
  }

  // Ticketing — Admin
  static async TICKETING_ADMIN_GET_EVENTS(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.TICKETING_ADMIN_EVENTS}${queryString ? '?' + queryString : ''}`, config);
  }

  static async TICKETING_ADMIN_GET_EVENT_TICKETS(eventId) {
    await this.getToken();
    return HttpService.get(`${API.TICKETING_ADMIN_EVENT_TICKETS}/${eventId}/tickets`, config);
  }

  static async TICKETING_ADMIN_GET_SCAN_LOGS(eventId) {
    await this.getToken();
    return HttpService.get(`${API.TICKETING_ADMIN_SCAN_LOGS}/${eventId}/scans`, config);
  }

  static async TICKETING_CANCEL_EVENT(eventId) {
    await this.getToken();
    return HttpService.post(`${API.TICKETING_CANCEL_EVENT}/${eventId}/cancel`, {}, config);
  }

  // Screening Room
  static async SCREENING_DASHBOARD() {
    await this.getToken();
    return HttpService.get(API.SCREENING_DASHBOARD, config);
  }

  static async SCREENING_LIST_ASSETS(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.SCREENING_ASSETS}${queryString ? '?' + queryString : ''}`, config);
  }

  static async SCREENING_UPLOAD_ASSET(formData, onUploadProgress) {
    await this.getToken();
    const uploadConfig = {
      headers: {
        Authorization: cookieStorage.getCookie("Authorization"),
      },
      timeout: 600000,
    };
    if (uploadConfig.headers.Authorization && !uploadConfig.headers.Authorization.startsWith('Bearer ')) {
      uploadConfig.headers.Authorization = `Bearer ${uploadConfig.headers.Authorization}`;
    }
    if (onUploadProgress) {
      uploadConfig.onUploadProgress = onUploadProgress;
    }
    return HttpService.post(API.SCREENING_ASSETS, formData, uploadConfig);
  }

  static async SCREENING_GET_ASSET(assetId) {
    await this.getToken();
    return HttpService.get(`${API.SCREENING_ASSETS}/${assetId}`, config);
  }

  static async SCREENING_UPDATE_ASSET(assetId, data) {
    await this.getToken();
    return HttpService.put(`${API.SCREENING_ASSETS}/${assetId}`, data, config);
  }

  static async SCREENING_ARCHIVE_ASSET(assetId) {
    await this.getToken();
    return HttpService.delete(`${API.SCREENING_ASSETS}/${assetId}`, config);
  }

  static async SCREENING_CREATE_LINK(assetId, data) {
    await this.getToken();
    return HttpService.post(`${API.SCREENING_ASSETS}/${assetId}/links`, data, config);
  }

  static async SCREENING_LIST_LINKS(assetId) {
    await this.getToken();
    return HttpService.get(`${API.SCREENING_ASSETS}/${assetId}/links`, config);
  }

  static async SCREENING_UPDATE_LINK(linkId, data) {
    await this.getToken();
    return HttpService.put(`${API.SCREENING_LINKS}/${linkId}`, data, config);
  }

  static async SCREENING_REVOKE_LINK(linkId) {
    await this.getToken();
    return HttpService.delete(`${API.SCREENING_LINKS}/${linkId}`, config);
  }

  static async SCREENING_LINK_ANALYTICS(linkId, params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.SCREENING_LINKS}/${linkId}/analytics${queryString ? '?' + queryString : ''}`, config);
  }

  static async SCREENING_ASSET_ANALYTICS(assetId, params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.SCREENING_ASSETS}/${assetId}/analytics${queryString ? '?' + queryString : ''}`, config);
  }

  static async SCREENING_DELETE_CONTENT(contentType, contentId) {
    await this.getToken();
    return HttpService.delete(`${API.SCREENING_DASHBOARD.replace('/dashboard', `/content/${contentType}/${contentId}`)}`, config);
  }

  static async SCREENING_UPDATE_VISIBILITY(contentType, contentId, visibility) {
    await this.getToken();
    return HttpService.patch(`${API.SCREENING_DASHBOARD.replace('/dashboard', `/content/${contentType}/${contentId}/visibility`)}`, { visibility }, config);
  }

  static async SCREENING_REORDER(order) {
    await this.getToken();
    return HttpService.put(`${API.SCREENING_DASHBOARD.replace('/dashboard', '/reorder')}`, { order }, config);
  }

  static async SCREENING_GET_PLAYBACK_URL(contentType, contentId) {
    await this.getToken();
    return HttpService.get(`${API.SCREENING_DASHBOARD.replace('/dashboard', `/play/${contentType}/${contentId}`)}`, config);
  }

  // Gallery
  static async GALLERY_PRESIGN(payload) {
    await this.getToken();
    return HttpService.post(API.GALLERY_PRESIGN, payload, config);
  }

  static async GALLERY_CREATE(payload) {
    await this.getToken();
    return HttpService.post(API.GALLERY_CREATE, payload, config);
  }

  static async GALLERY_BY_USER(userId, params = {}) {
    await this.getToken();
    const qs = new URLSearchParams(params).toString();
    return HttpService.get(`${API.GALLERY_BY_USER}${userId}${qs ? `?${qs}` : ""}`, config);
  }

  static async GALLERY_UPDATE(id, payload) {
    await this.getToken();
    return HttpService.patch(`${API.GALLERY_ITEM}${id}`, payload, config);
  }

  static async GALLERY_DELETE(id) {
    await this.getToken();
    return HttpService.delete(`${API.GALLERY_ITEM}${id}`, config);
  }

  // Toggle the current user's like on a photo.
  static async GALLERY_TOGGLE_LIKE(id) {
    await this.getToken();
    return HttpService.post(`${API.GALLERY_BASE}/${id}/like`, {}, config);
  }

  static async GALLERY_LIST_COMMENTS(id, params = {}) {
    await this.getToken();
    const qs = new URLSearchParams(params).toString();
    return HttpService.get(`${API.GALLERY_BASE}/${id}/comments${qs ? `?${qs}` : ""}`, config);
  }

  static async GALLERY_ADD_COMMENT(id, content) {
    await this.getToken();
    return HttpService.post(`${API.GALLERY_BASE}/${id}/comments`, { content }, config);
  }

  static async GALLERY_EDIT_COMMENT(commentId, content) {
    await this.getToken();
    return HttpService.patch(`${API.GALLERY_BASE}/comments/${commentId}`, { content }, config);
  }

  static async GALLERY_DELETE_COMMENT(commentId) {
    await this.getToken();
    return HttpService.delete(`${API.GALLERY_BASE}/comments/${commentId}`, config);
  }

  static async GALLERY_TOGGLE_COMMENT_LIKE(commentId) {
    await this.getToken();
    return HttpService.post(`${API.GALLERY_BASE}/comments/${commentId}/like`, {}, config);
  }

  // ── Gamification v2: engagement ──────────────────────────────────────
  static async ENGAGEMENT_ME() {
    await this.getToken();
    return HttpService.get(API.ENGAGEMENT_ME, config);
  }

  static async ENGAGEMENT_ME_MISSIONS() {
    await this.getToken();
    return HttpService.get(API.ENGAGEMENT_ME_MISSIONS, config);
  }

  static async ENGAGEMENT_ME_HISTORY(page = 1) {
    await this.getToken();
    return HttpService.get(`${API.ENGAGEMENT_ME_HISTORY}?page=${page}`, config);
  }

  // range=7|30|90: per-day XP + role activity for the Level & Analytics page.
  static async ENGAGEMENT_ME_TIMELINE(range = 30) {
    await this.getToken();
    return HttpService.get(`${API.ENGAGEMENT_ME_TIMELINE}?range=${range}`, config);
  }

  // New signups and returning visitors this user's shared links brought in.
  static async ENGAGEMENT_ME_SHARE_REACH() {
    await this.getToken();
    return HttpService.get(API.ENGAGEMENT_ME_SHARE_REACH, config);
  }

  // Streams, saves and contributors for a playlist page: 30-day sparkline + this week vs last.
  static async ENGAGEMENT_PLAYLIST_ACTIVITY(playlistId) {
    await this.getToken();
    return HttpService.get(`${API.ENGAGEMENT_PLAYLIST_ACTIVITY}/${playlistId}/activity`, config);
  }

  static async ENGAGEMENT_ME_REWARDS() {
    await this.getToken();
    return HttpService.get(API.ENGAGEMENT_ME_REWARDS, config);
  }

  static async ENGAGEMENT_ME_UNLOCKS() {
    await this.getToken();
    return HttpService.get(API.ENGAGEMENT_ME_UNLOCKS, config);
  }

  // Client-originated events only (powerplay.view, share.outbound, share.inbound).
  static async ENGAGEMENT_EVENT(payload) {
    await this.getToken();
    return HttpService.post(API.ENGAGEMENT_EVENT, payload, config);
  }

  static async ENGAGEMENT_ARTIST_TOP_FANS(artistId) {
    await this.getToken();
    return HttpService.get(`${API.ENGAGEMENT_ARTIST}/${artistId}/top-fans`, config);
  }

  // { fanId, kind, message?, badge?, code? }
  static async ENGAGEMENT_ARTIST_REWARD(payload) {
    await this.getToken();
    return HttpService.post(API.ENGAGEMENT_ARTIST_REWARD, payload, config);
  }

  // ── Gamification v2: artist insights ─────────────────────────────────
  static async INSIGHTS_ME_OVERVIEW(range = 30) {
    await this.getToken();
    return HttpService.get(`${API.INSIGHTS_ME_OVERVIEW}?range=${range}`, config);
  }

  static async INSIGHTS_ME_STREAMS(page = 1) {
    await this.getToken();
    return HttpService.get(`${API.INSIGHTS_ME_STREAMS}?page=${page}`, config);
  }

  static async INSIGHTS_ME_STREAM(channelName) {
    await this.getToken();
    return HttpService.get(`${API.INSIGHTS_ME_STREAMS}/${encodeURIComponent(channelName)}`, config);
  }

  static async INSIGHTS_ME_SONGS() {
    await this.getToken();
    return HttpService.get(API.INSIGHTS_ME_SONGS, config);
  }

  static async INSIGHTS_ME_AUDIENCE() {
    await this.getToken();
    return HttpService.get(API.INSIGHTS_ME_AUDIENCE, config);
  }

  static async INSIGHTS_ME_MOMENTUM() {
    await this.getToken();
    return HttpService.get(API.INSIGHTS_ME_MOMENTUM, config);
  }

  static async INSIGHTS_ME_MILESTONES() {
    await this.getToken();
    return HttpService.get(API.INSIGHTS_ME_MILESTONES, config);
  }

  static async INSIGHTS_ME_UNLOCKS() {
    await this.getToken();
    return HttpService.get(API.INSIGHTS_ME_UNLOCKS, config);
  }

  // ── Gamification v2: leaderboards ────────────────────────────────────
  // kind=trending|retention|growth|supported, scope=global|genre:<g>|city:<c>, range=7|30
  static async LEADERBOARDS_ARTISTS(params = {}) {
    await this.getToken();
    return HttpService.get(`${API.LEADERBOARDS_ARTISTS}?${serialize(params)}`, config);
  }

  // kind=requested|playlisted
  static async LEADERBOARDS_SONGS(params = {}) {
    await this.getToken();
    return HttpService.get(`${API.LEADERBOARDS_SONGS}?${serialize(params)}`, config);
  }

  // kind=top|curators|jukebox
  static async LEADERBOARDS_FANS(params = {}) {
    await this.getToken();
    return HttpService.get(`${API.LEADERBOARDS_FANS}?${serialize(params)}`, config);
  }

  static async LEADERBOARDS_ME_RANK(params = {}) {
    await this.getToken();
    return HttpService.get(`${API.LEADERBOARDS_ME_RANK}?${serialize(params)}`, config);
  }

  // ── Gamification v2: social proof + notification preferences ─────────
  static async SOCIAL_PROOF_ASSET(type, id) {
    await this.getToken();
    return HttpService.get(`${API.SOCIAL_PROOF_ASSET}/${type}/${id}`, config);
  }

  static async NOTIFICATION_PREFERENCES_GET() {
    await this.getToken();
    return HttpService.get(API.NOTIFICATION_PREFERENCES, config);
  }

  // { [type]: boolean }
  static async NOTIFICATION_PREFERENCES_PUT(payload) {
    await this.getToken();
    return HttpService.put(API.NOTIFICATION_PREFERENCES, payload, config);
  }
}
